import { Link } from 'react-router-dom'
import { useLanguage } from '../../i18n/LanguageContext'

export function MagacinLogo({ className = '' }: { className?: string }) {
  const { t } = useLanguage()
  return (
    <Link to="/" className={`inline-flex shrink-0 items-center ${className}`} aria-label={t('Magacin home')}>
      <img src="/brand/magacin-logo-transparent.png" alt="Magacin" width="1000" height="1000" className="h-9 w-9 object-contain brightness-0 invert sm:h-10 sm:w-10" />
    </Link>
  )
}
